import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../pageWrapper";

//CSS
import "../0PageStyles.css";
import "./announcementPage.css";

//Components
import InputField from "../../Components/Other Components/inputField";
import Button from "../../Components/Other Components/button";
import PageLoader from "../../Components/Other Components/pageLoader";
import EmployeePicker from "../../Components/Employee Components/employeePicker";
import MandatoryExplanation from "../../Components/Other Components/mandatoryExplanation";

//Functions and hooks
import { useErrorHandler } from "../../hooks/errorHandler";
import { useNotification } from "../../Contexts/NotificationContext";
import { SendAnnouncement } from "../../BackendAccess/MessageHooks";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import { useTranslation } from "react-i18next";

export default function AnnouncementPage({}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);
  const isNarrow = useNarrowMode();

  const navigate = useNavigate();

  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");

  const [sendEnabled, setSendEnabled] = useState(true);

  const { t } = useTranslation();

  const handleSelectedEmployeesChange = (e) => {
    setSelectedEmployees(e);
  };
  const handleBodyChange = (e) => {
    setBody(e);
  };
  const handleHeaderChange = (e) => {
    setHeader(e);
  };

  const onSend = async () => {
    setLoading(true);
    setSendEnabled(false);
    try {
      const [data, error] = await SendAnnouncement(
        header,
        body,
        selectedEmployees
      );
      if (error) {
        setError(error);
      } else {
        showNotification(
          t("Announcement sent successfully!", { ns: "employees" }),
          "success"
        );
        navigate(-1);
      }
    } catch (err) {
      setError({
        err: t("server.Server error.", { ns: "error" }),
        errCode: 500,
      });
    } finally {
      setSendEnabled(true);
      setLoading(false);
    }
  };
  const onCancel = () => {
    navigate(-1);
  };

  const tutorialSteps = [
    {
      target: null,
      title: t("Sending an announcement", { ns: "tutorial" }),
      message: t(
        "This page sends a message to some or all of your employees at once - it'll show up in their Messages page.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "announcement-header",
      title: t("Header", { ns: "tutorial" }),
      message: t(
        "Optional. A short title shown at the top of the message.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "announcement-body",
      title: t("Body", { ns: "tutorial" }),
      message: t(
        "The announcement's main text - this is what your employees will actually read.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "announcement-employees",
      title: t("Recipients", { ns: "tutorial" }),
      message: t(
        "Choose which employees should receive this announcement. Leave none selected to send it to everyone.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "announcement-send-btn",
      title: t("Send", { ns: "tutorial" }),
      message: t(
        "Once you're happy with the message, click here to send it.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="announcement" tutorialSteps={tutorialSteps}>
      <PageLoader error={pageError} loading={loading}>
        <div className="page-content">
          <div className="container-bordered flex-col w-90 mt-4">
            <InputField
              label={t("Header") + ":"}
              value={header}
              onChange={handleHeaderChange}
              tutorialId="announcement-header"
            ></InputField>
            <InputField
              largeField={true}
              label={t("Body") + ":"}
              value={body}
              onChange={handleBodyChange}
              mandatory={true}
              tutorialId="announcement-body"
            ></InputField>
            <MandatoryExplanation />
          </div>

          <div data-tutorial-id="announcement-employees">
            <EmployeePicker
              className="w-90 mt-4"
              onChange={handleSelectedEmployeesChange}
              initSelectedEmployees={selectedEmployees}
            />
          </div>
          <div className="btn-container mt-3">
            <Button
              btnStyle={"btn-positive"}
              acceptEnter={true}
              icon="apply"
              className={isNarrow ? "mb-2" : ""}
              onClick={onSend}
              disabled={!sendEnabled}
              tutorialId="announcement-send-btn"
            >
              {t("Send")}
            </Button>
            <Button onClick={onCancel}>{t("Cancel")}</Button>
          </div>
        </div>
      </PageLoader>
    </PageWrapper>
  );
}
